var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-2"},[_c('span',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Response')))]),_c('span',{staticClass:"font-bold"},[_vm._v("\n    "+_vm._s(_vm.submissions)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }